import FocusGuard from "src/decidim/focus_guard";
const DESKTOP_BREAKPOINT = "1024px";
$(() => {
  const closeFiltersBtn = document.querySelectorAll("[id=close-filters-btn]");
  const filters = document.getElementById("filters");
  const filtersFocusGuard = new FocusGuard(filters);
  const categoriesList = document.querySelectorAll(".category_element");
  const showMoreBtnCategories = document.getElementById("show-more-btn-categories");
  const btnCategoriesText = showMoreBtnCategories.querySelector("span");
  const formsList = document.querySelectorAll(".form_element");
  const showMoreBtnForms = document.getElementById("show-more-btn-forms");
  const btnFormsText = showMoreBtnForms.querySelector("span");
  const agesList = document.querySelectorAll(".age_element");
  const showMoreBtnAges = document.getElementById("show-more-btn-ages");
  const btnAgesText = showMoreBtnAges.querySelector("span");
  const eventStartDateContainer = document.getElementById("event-start-date");
  const eventEndDateContainer = document.getElementById("event-end-date");
  const hiddenEventStartDateInput = eventStartDateContainer.querySelector('input[name="filter[start_date]"]');
  const hiddenEventEndDateInput = eventEndDateContainer.querySelector('input[name="filter[end_date]"]');
  const visibleEventStartDateInput = eventStartDateContainer.querySelector(".datepicker__date-column input");
  const visibleEventEndDateInput = eventEndDateContainer.querySelector(".datepicker__date-column input");
  handleDateInputChange(visibleEventStartDateInput, hiddenEventStartDateInput);
  handleDateInputChange(visibleEventEndDateInput, hiddenEventEndDateInput);
  handleFilterDatePick(eventStartDateContainer);
  handleFilterDatePick(eventEndDateContainer);
  if (categoriesList.length > 5) {
    categoriesList.forEach((item, index) => {
      if (index >= 5) item.classList.add("categories-extra", "hidden");
    });
    showMoreBtnCategories.classList.remove("hidden");
  }
  if (formsList.length > 5) {
    formsList.forEach((item, index) => {
      if (index >= 5) item.classList.add("forms-extra", "hidden");
    });
    showMoreBtnForms.classList.remove("hidden");
  }
  if (agesList.length > 5) {
    agesList.forEach((item, index) => {
      if (index >= 5) item.classList.add("ages-extra", "hidden");
    });
    showMoreBtnAges.classList.remove("hidden");
  }
  btnCategoriesText.textContent = showMoreBtnCategories.getAttribute("data-show");
  showMoreBtnCategories.addEventListener("click", function() {
    document.querySelectorAll(".categories-extra").forEach((item) => item.classList.toggle("hidden"));
    const isExpanded = btnCategoriesText.textContent === showMoreBtnCategories.getAttribute("data-show");
    btnCategoriesText.textContent = isExpanded ? showMoreBtnCategories.getAttribute("data-hide") : showMoreBtnCategories.getAttribute("data-show");
  });
  btnFormsText.textContent = showMoreBtnForms.getAttribute("data-show");
  showMoreBtnForms.addEventListener("click", function() {
    document.querySelectorAll(".forms-extra").forEach((item) => item.classList.toggle("hidden"));
    const isExpanded = btnFormsText.textContent === showMoreBtnForms.getAttribute("data-show");
    btnFormsText.textContent = isExpanded ? showMoreBtnForms.getAttribute("data-hide") : showMoreBtnForms.getAttribute("data-show");
  });
  btnAgesText.textContent = showMoreBtnAges.getAttribute("data-show");
  showMoreBtnAges.addEventListener("click", function() {
    document.querySelectorAll(".ages-extra").forEach((item) => item.classList.toggle("hidden"));
    const isExpanded = btnAgesText.textContent === showMoreBtnAges.getAttribute("data-show");
    btnAgesText.textContent = isExpanded ? showMoreBtnAges.getAttribute("data-hide") : showMoreBtnAges.getAttribute("data-show");
  });
  $(document).on("click", "#show-filters-btn", (event) => {
    filters.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    filtersFocusGuard.trap(filters, event.target);
    closeFiltersBtn[0].focus();
  });
  closeFiltersBtn.forEach((element) => {
    element.addEventListener("click", () => {
      hideFilters();
    });
  });
  window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT})`).addEventListener("change", () => {
    hideFilters();
  });
  function hideFilters() {
    filters.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
    filtersFocusGuard.disable();
  }
  function handleFilterDatePick(rootElement) {
    rootElement.addEventListener("wc-datepicker.ready", (e) => {
      const datePickButton = rootElement.querySelector(".datepicker__pick-calendar");
      datePickButton.addEventListener("click", () => {
        $(rootElement).find('input[type="text"]').trigger("change");
      });
    });
  }
  function handleDateInputChange(visibleDateInput, hiddenInputDate) {
    visibleDateInput.addEventListener("keydown", (event) => {
      if (event.code !== "Enter") {
        return;
      }
      hiddenInputDate.value = "";
      $(visibleDateInput).trigger("change");
    });
  }
});
